<template>
    <div class="spackageCatalogEdit form dialog-form">
        <el-dialog title="目录编辑" :visible.sync="dialogFormVisible" width="600px">
            <el-form :model="item" label-width="120px" ref="catalogue" :rules="catalogue"  class="demo-ruleForm" label-position="left" size="mini">
                <el-form-item label="目录名称" prop="subject">
                    <el-input v-model="item.subject" auto-complete="off" placeholder="请输入目录名称，不超过30字。"></el-input>
                </el-form-item>
                <el-form-item label="简要介绍" prop="description">
                    <el-input type="textarea" v-model="item.description" :rows="4" placeholder="请输入简介，不超过80字。"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit('catalogue')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {editCatalogue} from '@/api/spackageApi'
export default {
    name: 'spackageCatalogEdit',
    data() {
        return {
            item: {
                subject: '',
                description: '',
                assetInnerID: ''
            },
            dialogFormVisible: false,
            catalogue: {
                subject: [
                    {min: 1, max: 30, message: '字符长度在1 到 30', trigger: 'blur'}
                ],
                description: [
                    {min: 0, max: 80, message: '请不要输入超过80个字符的长度', trigger: 'blur'}
                ]
            }
        }
    },
    props: [
        'innerid', 'pageData'
    ],
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.dialogFormVisible = true
            this.item.assetInnerID = row.innerid
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    editCatalogue({
                        data: Object.assign({}, this.item, {innerid: this.innerid}),
                        success: data => {
                            if (data.code === '000') {
                                this.$emit('list', this.pageData)
                                this.dialogFormVisible = false
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功'
                                })
                            }
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .spackageCatalogEdit {
        .el-textarea__inner{
            resize: none;
        }
    }
</style>
